<template>
    <form-fields :no-padding="true">
        <form-fields-main-scroll>
            <step-info
                :label="$t('V3_EDIT_MONOGRAM')"
            />

            <design-monogram-entry-toolbar
                :buttons-sm="true"
            />

            <transition name="cz2__fade">
                <div class="cz3__all-toolbar" v-if="hasText">
                    <step-info
                        :label="$t('V3_EDIT_MONOGRAM_FONT')"
                    />

                    <design-monogram-font-toolbar
                        :buttons-sm="true"
                    />

                    <step-info
                        v-if="personalizationMethod === 'printing'"
                        :label="$t('V3_EDIT_MONOGRAM_COLOR')"
                    />

                    <design-monogram-color-toolbar
                        v-if="personalizationMethod === 'printing'"
                        :buttons-sm="true"
                        :max-items="14"
                    />

                    <step-info
                        :label="$t('V3_EDIT_MONOGRAM_ALIGNMENT')"
                    />

                    <design-monogram-alignment-toolbar
                        :buttons-sm="true"
                    />
                </div>
            </transition>
        </form-fields-main-scroll>

        <step-buttons :add-padding="true">
            <secondary-button
                class="cz3__flex-1"
                :label="$t('V3_BACK')"
                @click="back"
            />

            <action-button
                class="cz3__flex-1"
                :label="$t('V3_NEXT')"
                :disabled="!textEntered"
                @click="next"
            />
        </step-buttons>
    </form-fields>
</template>

<script>
    import FormFields from './FormFields.vue';
    import FormFieldsMainScroll from './FormFieldsMainScroll.vue';
    import DesignMonogramEntryToolbar from './DesignMonogramEntryToolbar.vue';
    import DesignMonogramColorToolbar from './DesignMonogramColorToolbar.vue';
    import DesignMonogramFontToolbar from './DesignMonogramFontToolbar.vue';
    import DesignMonogramAlignmentToolbar from './DesignMonogramAlignmentToolbar.vue';
    import StepButtons from './StepButtons.vue';
    import ActionButton from './ActionButton.vue';
    import SecondaryButton from './SecondaryButton.vue';
    import StepInfo from './StepInfo.vue';

    import isFilled from '../../utilities/isFilled';

    export default {
        components: {
            FormFields,
            FormFieldsMainScroll,
            DesignMonogramEntryToolbar,
            DesignMonogramColorToolbar,
            DesignMonogramFontToolbar,
            DesignMonogramAlignmentToolbar,
            StepButtons,
            ActionButton,
            SecondaryButton,
            StepInfo,
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            editPlacements() {
                return this.$store.state.customizer.editPlacements;
            },

            editPlacement() {
                if (this.editPlacements && this.editPlacements.length > 0) {
                    return this.editPlacements[0];
                }

                return null;
            },

            editComponent() {
                if (this.editPlacement) {
                    return this.viewController.selectedAtPlacement(this.editPlacement.code);
                }

                return null;
            },

            personalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },

            hasText() {
                return this.editComponent;
            },

            textEntered() {
                if (this.editComponent) {
                    if (isFilled(this.editComponent)) {
                        const text = this.editComponent.custom['personalization-text'];

                        if (text && text.length > 0) {
                            return true;
                        }
                    }
                }

                return false;
            },

            nextStep() {
                return this.$store.getters.nextStepV3;
            },
        },

        methods: {
            back() {
                this.$store.dispatch('setSelectedSubStepV3', 'choose');
            },

            next() {
                if (this.nextStep) {
                    this.$store.dispatch('setSelectedStepV3', this.nextStep);
                }
            },
        },
    };
</script>
